import { BasicClassGroup, ComponentClassGroup, IBasicClassGroup, IComponentClassGroup } from "./class-groups";

// base system styles

export interface PropsWithClassNames {
  classNames?: ClassNames;
}

export type ClassName = string | BaseClassNames;

export type ClassNames = string[] | BaseClassNames[];

export type IBaseClassGroup = IBasicClassGroup & IComponentClassGroup;
export type BaseClassNames = keyof IBaseClassGroup;

export const BaseClassGroup = {
  ...BasicClassGroup,
  ...ComponentClassGroup,
};
